import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './LoginPage';  // Componenta pentru login
import UploadPage from './UploadPage'; // Componenta pentru încărcarea fișierelor
import DataPage from './DataPage';     // Componenta pentru afisarea datelor

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} /> {/* Login Page */}
        <Route path="/upload" element={<UploadPage />} /> {/* Upload Page */}
        <Route path="/:sessionId" element={<DataPage />} /> {/* Data Page */}
      </Routes>
    </Router>
  );
};

export default AppRouter;
